export const navigateNav = (navigate: any, link: string, e?: any, closeRef?: React.RefObject<HTMLButtonElement | null>) => {
    if(e)
        e.preventDefault();
    
    if (closeRef && closeRef.current)
        closeRef.current.click()

    if(link.includes("http")){
        window.open(link, '_blank');
        return;
    }

    navigate(link)
}